export const DOCUMENT_TYPE = {
  INVOICE: 1,
  DELIVERY_NOTE: 2,
};

export const DOCUMENT_TYPE_LABEL: Record<number, string> = {
  [DOCUMENT_TYPE.INVOICE]: 'Factura',
  [DOCUMENT_TYPE.DELIVERY_NOTE]: 'Comprobante de recibo',
}

export const DOCUMENT_TYPES = [
  { name: DOCUMENT_TYPE_LABEL[DOCUMENT_TYPE.INVOICE], value: DOCUMENT_TYPE.INVOICE },
  { name: DOCUMENT_TYPE_LABEL[DOCUMENT_TYPE.DELIVERY_NOTE], value: DOCUMENT_TYPE.DELIVERY_NOTE },
]